export default () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
		<path fill="#367BF5" fillRule="evenodd" d="M7 14l5-5 5 5H7z" clipRule="evenodd" />
	</svg>
);
